import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { get } from 'lodash';

import ChoiceChip from '../../choice-chip';
import { getCharByElementPosition, parseElement } from '../../../lib/exercise';
import MathContent from '../../math-content';
import FluidContainer from '../../layouts/components/fluid-container';
import Spacer from '../../spacer';

export const Label = styled.span`
    display: inline-block;
    font-weight: 600;
    margin-right: 4px;
    margin-top: 8px;
`;

const Feedback = styled.span`
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    margin-top: 8px;
`;

export const CorrectChoiceChip = styled.span`
    margin-top: 8px;
`;

export function getFeedbackTypes(answers, gapList, options) {
    return gapList.map((item) => {
        const selectedAnswer = answers.find((answer) => answer.gapId === item.id);
        const selectedAnswerText = get(
            options.find((item) => item.id === get(selectedAnswer, 'optionId')),
            'values[0].text',
        );
        const selectedAnswerId = get(selectedAnswer, 'optionId');

        switch (selectedAnswerText) {
            case undefined:
                return { ...item, selectedAnswerId: null, type: 'missing' };
            case item.text:
                return { ...item, selectedAnswerId: selectedAnswerId, type: 'success' };
            default:
                return { ...item, selectedAnswerId: selectedAnswerId, type: 'error' };
        }
    });
}

function getLabel(type) {
    switch (type) {
        case 'success':
            return 'Risposta corretta.';
        case 'error':
            return 'Risposta sbagliata.';
        case 'missing':
        default:
            return 'Risposta non data.';
    }
}

export const SingleDragDropFeedback = ({ correctAnswer, selectedAnswer, type, index }) => {
    return (
        <>
            <FluidContainer marginRight="regular">
                <ChoiceChip
                    id={`${index}`}
                    key={`${index}`}
                    badgeIndex={getCharByElementPosition(index + 1)}
                    value={type === 'error' ? selectedAnswer.values[0].text : correctAnswer.values[0].text}
                    type="validated"
                    validationType={type}
                />
            </FluidContainer>
            <FluidContainer flexDirection="column" marginLeft="regular" marginRight="regular">
                <div>
                    <Label>{getLabel(type)}</Label>
                    <Feedback>
                        <MathContent style={{ display: 'inline' }}>
                            {type === 'missing' ? correctAnswer.feedback : selectedAnswer.feedback}
                        </MathContent>
                    </Feedback>
                </div>

                {type === 'error' && (
                    <FluidContainer flexDirection="column">
                        <Label>{'La risposta corretta è:'}</Label>
                        <CorrectChoiceChip>
                            <ChoiceChip type="validated" validationType="missing" value={correctAnswer.values[0].text} />
                        </CorrectChoiceChip>
                    </FluidContainer>
                )}
            </FluidContainer>
        </>
    );
};

SingleDragDropFeedback.propTypes = {
    correctAnswer: PropTypes.object,
    index: PropTypes.number,
    selectedAnswer: PropTypes.object,
    type: PropTypes.string,
};

const DragDropFeedback = ({ exercise, answers }) => {
    const gapList = Array.from(parseElement(exercise.question, exercise.options));
    let parsedGapList = gapList.map((item) => {
        return {
            id: item[0].replace('_', ''),
            correctAnswerId: item[1].responseId,
            char: item[1].char,
            text: item[1].text,
        };
    });
    let correctedGapList = getFeedbackTypes(answers, parsedGapList, exercise.options);

    return (
        <FluidContainer flexDirection="column" marginTop={['mobile', 'mobile', 'desktop']} paddingBottom="mobile">
            {correctedGapList.map((gap, index) => {
                const selectedAnswer = exercise.options.find((option) => option.id === gap.selectedAnswerId);
                const correction = exercise.options.find((option) => option.id === gap.correctAnswerId);
                return (
                    <div key={index}>
                        <SingleDragDropFeedback
                            key={index}
                            index={index}
                            type={gap.type}
                            correctAnswer={correction}
                            selectedAnswer={selectedAnswer}
                        />
                        {index < correctedGapList.length - 1 && <Spacer size="regular" />}
                    </div>
                );
            })}
        </FluidContainer>
    );
};

DragDropFeedback.propTypes = {
    answers: PropTypes.array,
    exercise: PropTypes.object,
};

export default DragDropFeedback;
